import React from "react";
import {
    Select,
    Checkbox,
    Row,
    Col,
    Button,
    Space,
    DatePicker,
    Dropdown,
    Modal,
    Tooltip,
    message
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import { DeleteFilled, DownOutlined, PlusOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import FuelDropReportStore from "../store/FuelDropReportStore";
import config from "../config";

const { RangePicker } = DatePicker;
const { Option } = Select;
class FuelDropReportList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.fuelDropReportStore = new FuelDropReportStore(this)
        this.vehicleStore = new VehicleStore();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            selectedVehicles: null,
            selectAllVehicles: false,
            companyId: "",
            modalVisible: false,
            column: "",
            showMonthPopup: false,
            Notcompany: false,
            Notasset: false,
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            Notdate: false,
            openInvalidateRecordPopup: false,
            invalidateRecordData: {},
            selectedColumns: [
                {
                    title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                },
                {
                    title: context.translate("_FLEET_DASHBORD_SETTING_DATE_"),
                    dataIndex: "timestamp",
                    key: "timestamp",
                },
                {
                    title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
                    dataIndex: "location",
                    key: "location",
                },
                {
                    title: context.translate("_BEFORE_REFILL_LTRS_"),
                    dataIndex: "beforeLevel",
                    key: "beforeLevel",
                },
                {
                    title: context.translate("_AFTER_FUEL_LEVEL_LTRS_"),
                    dataIndex: "afterLevel",
                    key: "afterLevel",
                },
                {
                    title: context.translate("_FUEL_DROP_"),
                    dataIndex: "fuelDrop",
                    key: "fuelDrop",

                },
                {
                    title: context.translate("_ACTION_"),
                    dataIndex: "action",
                    key: "action",
                    render: (val, record) => {
                        return (
                            <Tooltip
                                title={this.context.translate(
                                    "_INVALIDATE_RECORD_"
                                )}
                                placement="bottom"
                                color={config.tooltipColorDelete}
                            >
                                <DeleteFilled style={{ color: config.deleteColor, fontSize: 15, cursor: "pointer" }}
                                    onClick={() => {
                                        this.setState({ openInvalidateRecordPopup: true, invalidateRecordData: record })
                                    }} />
                            </Tooltip>
                        )
                    }
                },
            ],
        };

        this.newColumns = [...this.state.selectedColumns];
    }
    async componentDidMount() {
        this.menuProps = {
            items: [
                {
                    label: this.context.translate("_EXCEL_"),
                    key: "excel",
                    icon: <PlusOutlined />,
                },
                {
                    label: this.context.translate("_PDF_"),
                    key: "pdf",
                    icon: <PlusOutlined />,
                },
            ],
            onClick: (val) => {
                let result = [];
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    var getData = {
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        colList: result.toString(),
                    };
                    if (val.key === "excel") {
                        this.fuelDropReportStore.exportExcel(getData);
                    }
                    if (val.key === "pdf") {
                        this.fuelDropReportStore.exportpdf(getData);
                    }
                }
            },
        };
        this.setState({ pageSize: 50 });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        this.setState({ selectedVehicles: null, selectAllVehicles: false });

        await this.setState({ companyId: comp?.value });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);

        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ Notasset: false });
        // await this.fuelDropReportStore.loadData({
        //   offset: (this.state.currentPage - 1) * this.state.pageSize,
        //   limit: this.state.pageSize,
        //   companyId: this.state.companyId,
        //   pageNo: this.state.currentPage,
        // });
        await this.setState({ loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }

    showData = async () => {
        this.setState({ loading: true });
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.selectedVehicles) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (!this.state.fromDate) {
            this.setState({ Notdate: true });
        } else {
            this.setState({ Notdate: false });
        }

        if (
            this.state.companyId &&
            this.state.selectedVehicles &&
            this.state.fromDate &&
            this.state.toDate
        ) {
            // this.setState({mandatory:false})
            this.setState({ Notcompany: false, Notasset: false, Notdriver: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.fuelDropReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    vehicleId: this.state.selectedVehicles,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    pageNo: this.state.currentPage,
                });
                this.setState({ loading: true });
            }
        }
    };

    handleCheckboxChange = async (column) => {
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };
    addMonths = (date, months) => {
        var indx = dayjs().month() + -6;
        return dayjs().month(indx);
    };

    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" });
        }
    };

    handleAllSelectVehicles = async () => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    handleSelectAllDrivers = async (e) => {
        if (this.state.selectAllDrivers) {
            const allDrivers = this.fuelDropReportStore?.getDrivers.map((val) => {
                return val.driverId;
            });
            await this.setState({ selectedDriver: allDrivers });
        } else {
            await this.setState({ selectedDriver: [] });
        }
    };

    handleInValidateData = async () => {
        const data = this.state.invalidateRecordData

        console.log(data, "data")
        const postData = {
            mt90Id: data.mt90Id,
            reportId: data.reportId,
            timestamp: data.timestamp,
            vehicleId: data.vehicleId,
            beforeLevel: data.beforeLevel
        }
        const response = await this.fuelDropReportStore.invalidateData(postData)
        console.log(response.data.success)
        if (response.data.success === "S") {
            message.success(response.data.message)
            this.setState({ openInvalidateRecordPopup: false })
            this.showData()
        }

    }

    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_FUEL_DROP_REPORT_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction === "ltr" ? "right" : "left",
                                }}
                            >
                                <Dropdown
                                    menu={this.menuProps}
                                    disabled={
                                        this.fuelDropReportStore?.fuelDropReport?.length > 0 ? false : true
                                    }
                                >
                                    <Button className="exportDropdown">
                                        <Space>
                                            {this.context.translate("_EXPORT_")}
                                            <DownOutlined />
                                        </Space>
                                    </Button>
                                </Dropdown>

                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {/* Columns */}
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    allowClear={true}
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                {this.props.getUserData().isadmin === 1 && (
                                    <DeviceGroupsForVehicles
                                        vehicleStore={this.vehicleStore}
                                        setLoadDta={() => this.setState({ loadData: 1 })}
                                        resetVehicles={() =>
                                            this.setState({
                                                selectedVehicles: [],
                                                selectAllVehicles: false,
                                            })
                                        }
                                    />
                                )}
                                {/* <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    await this.handleAllSelectVehicles();
                  }}
                />
                {this.context.translate("_ALL_")} */}

                                <Select
                                    className="searchInput"
                                    // maxTagCount="responsive"
                                    value={this.state.selectedVehicles ? this.state.selectedVehicles : null}
                                    onChange={(val) => {
                                        this.setState({ selectedVehicles: val });
                                        if (
                                            this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllVehicles: false });
                                        } else {
                                            this.setState({ selectAllVehicles: true });
                                        }
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    // mode="multiple"
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option key={val.vehicleId} value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>

                                <RangePicker
                                    status={this.state.Notdate ? "error" : false}
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [
                                            dayjs().startOf("day"),
                                            dayjs().endOf("day"),
                                        ],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                                />
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Space>
                        </Col>

                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.fuelDropReportStore?.total}
                        columns={this.state.column}
                        dataSource={this.fuelDropReportStore?.fuelDropReport}
                        loading={this.fuelDropReportStore?.loading}
                        onChange={this.handleTableChange}
                    />

                    <Modal
                        width={350}
                        className="alert-model"
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {/* Alert */}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        open={this.state.showMonthPopup}
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {/* For reports prior to 6 months please contact administrator */}
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>


                    <Modal
                        width={380}
                        className="alert-model"
                        title={this.context.translate("_CONFIRM_")}
                        open={this.state.openInvalidateRecordPopup}
                        onOk={() => this.setState({ openInvalidateRecordPopup: false })}
                        onCancel={() => this.setState({ openInvalidateRecordPopup: false })}
                        footer={false}
                    >
                        {this.context.translate("_CONFIRM_INVALIDATE_")}

                        <div className="invalidate-report-cls">
                            <Button onClick={() => this.handleInValidateData()}>
                                {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
                            </Button>
                        </div>

                    </Modal>
                </div>
            </>
        );
    }
}
FuelDropReportList.contextType = StoreContext;
export default observer(withRouter(FuelDropReportList));
